import { render, staticRenderFns } from "./StaffGroupEditForm.vue?vue&type=template&id=26316996&scoped=true&"
import script from "./StaffGroupEditForm.vue?vue&type=script&lang=js&"
export * from "./StaffGroupEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26316996",
  null
  
)

export default component.exports